module.exports = __webpack_public_path__ + "static/img/peopleGame1.9a8165e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/peopleGame1.png
// module id = WAZR
// module chunks = 3